import React from 'react';
import { LocalizationProvider, Text } from 'ilenia';
import { connect } from 'react-redux';
import * as flat from 'flat';
import styled from '@emotion/styled';
import { Stepper } from '@trustpilot/businessapp-patternlibrary';
import {
  shop as shopActions,
  trustpilot as trustpilotActions,
} from './actions';
import translations from './localization/en-US/string.json';
import { PlanDetails } from './PlanDetails';
import BillingInfoAndConditions from './BillingInfoAndConditions';
import { BillingPricingDetails, BusinessUnitDetails } from './models';
import * as analyticsActions from './actions/analytics';
import Auth from './Auth';

const mock = {
  hidePricing: false,
};
// I 'll leave commented code as an example - needs to be removed later on. TODO
interface AppProps {
  getStoreDetails: () => void;
  receiveStoreDetails: (details: any) => void;
  getOrder: () => void;
  loggedStatus: () => any;
  isFetchingOrder: boolean;
  pricing: BillingPricingDetails;
  isFetchingPricing: boolean;
  loadAnalytics: () => void;
  businessUnitDetails: BusinessUnitDetails;
  isFetchingStoreDetails: boolean;
  isLogged: boolean;
  accessCheckInProgress: boolean;
  isFetchingBusinessModuleId: boolean;
  businessModuleId: string;
  businessModuleName: string;
  createOrderFailure: () => void;
}

class App extends React.Component<AppProps> {
  constructor(props: AppProps) {
    super(props);
    this.receiveSettings = this.receiveSettings.bind(this);
  }

  componentDidMount(): void {
    window.addEventListener('message', this.receiveSettings);
    this.props.loggedStatus();
  }

  receiveSettings(e: MessageEvent): void {
    try {
      if (e.data) {
        const decodeddData = atob(e.data);
        const data = JSON.parse(decodeddData);
        if (data?.actionName === 'upgrade_error') {
          this.props.createOrderFailure();
        }
        // TODO move to cloudformation
        if (data?.actionName === 'billingapp_data') { // } && e.origin === process.env.REACT_APP_ShopifyAppUrl) {
          this.props.receiveStoreDetails(data);
          this.props.getOrder();
          this.props.loadAnalytics();
        }
      }
    } catch (e) {
      console.log('Message received but it cannot be parsed');
    }
  }

  render(): JSX.Element | null {
    const {
      isFetchingOrder,
      isFetchingPricing,
      pricing,
      businessUnitDetails,
      isFetchingStoreDetails,
      isLogged,
      accessCheckInProgress,
      isFetchingBusinessModuleId,
      businessModuleId,
      businessModuleName,
    } = this.props;

    if (accessCheckInProgress && isFetchingOrder) {
      return null;
    }

    const BillingForm = (
      <div>
        <StyledStepper>
          <Stepper activeStep={1}>
            <Stepper.Item><Text id="main.step1" /></Stepper.Item>
            <Stepper.Item><Text id="main.step2" /></Stepper.Item>
          </Stepper>
        </StyledStepper>
        <StyledPageContainer>
          <StyledLeftColumn>
            <BillingInfoAndConditions />
          </StyledLeftColumn>
          <StyledRightColumn>
            {!isFetchingBusinessModuleId && !isFetchingPricing && !isFetchingStoreDetails && (
              <PlanDetails
                hidePricing={mock.hidePricing}
                pricing={pricing}
                businessUnitName={businessUnitDetails.businessUnitName}
                businessModuleId={businessModuleId}
                businessModuleName={businessModuleName}
              />
            )}
          </StyledRightColumn>
        </StyledPageContainer>
      </div>
    );

    return (
      <LocalizationProvider locale="en-US" translations={flat.flatten(translations)}>
        <StyledDefaults>
          <StyledMainContainer>
            <StyledContentContainer>
              { isLogged ? BillingForm : <Auth /> }
            </StyledContentContainer>
          </StyledMainContainer>
        </StyledDefaults>
      </LocalizationProvider>
    );
  }
}

const verticalLayoutMediaQuery = '@media (max-width: 1023px)';

const StyledDefaults = styled.div({
  fontSize: '14px',
  letterSpacing: '0px',
  lineHeight: '20px',
});

const StyledMainContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  margin: '0 15px',
  paddingBottom: 40,
});

const StyledContentContainer = styled.div({
  maxWidth: 1136,
  width: '100%',
});

const StyledStepper = styled.div({
  margin: '20px 0',
  '& ol': {
    padding: '0',
  },
});

const StyledPageContainer = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  [verticalLayoutMediaQuery]: {
    flexDirection: 'column-reverse',
  },
});

const StyledLeftColumn = styled.div({
  flex: 6,
});

const StyledRightColumn = styled.div({
  marginLeft: 16,
  flex: 3,
  height: 'fit-content',
  [verticalLayoutMediaQuery]: {
    marginLeft: 0,
    marginBottom: 8,
  },
});

const mapStateToProps = (state: any) => ({
  isFetchingOrder: state.shop.isFetchingOrder,
  pricing: state.pricing.pricing,
  isFetchingPricing: state.pricing.isFetchingPricing,
  businessUnitDetails: state.businessUnit.details,
  isFetchingStoreDetails: state.shop.isFetchingStoreDetails,
  accessCheckInProgress: state.trustpilot.inProgress,
  isLogged: state.trustpilot.isLogged,
  isFetchingBusinessModuleId: state.businessModule.isFetchingId,
  businessModuleId: state.businessModule.id,
  businessModuleName: state.businessModule.name,
});

const mapDispatchToProps = (dispatch: any) => ({
  getStoreDetails: () => dispatch(shopActions.getStoreDetails()),
  receiveStoreDetails: (details: any) => dispatch(shopActions.receiveStoreDetails(details)),
  getOrder: () => dispatch(shopActions.getOrder()),
  loggedStatus: () => dispatch(trustpilotActions.getLoggedStatus()),
  loadAnalytics: () => dispatch(analyticsActions.loadAnalytics()),
  createOrderFailure: () => dispatch(shopActions.createOrderFailure()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
